export default function CTASection() {
  return (
    <div className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-gray-900 mb-6">
          물 관리 시스템을 혁신할 준비가 되셨나요?
        </h2>
        <p className="text-xl text-gray-600 mb-8">
          SIENG를 사용하여 물 시스템을 최적화하고 지속 가능한 운영을 보장하는
          수백 개의 조직에 합류하세요
        </p>
        <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
          <button className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white font-medium py-4 px-8 rounded-xl transition-colors cursor-pointer whitespace-nowrap">
            데모 요청
          </button>
          <button className="w-full sm:w-auto border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white font-medium py-4 px-8 rounded-xl transition-colors cursor-pointer whitespace-nowrap">
            자세히 알아보기
          </button>
        </div>
      </div>
    </div>
  );
}
